import { Grid, Typography } from '@mui/material';
import CustomTooltip from 'components/custom-tooltip';
import { convertBytes } from 'utils/helpers';
import TrashIcon from 'assets/icons/file-cabinet-trash/trash.svg';
import DotIcon from 'assets/icons/cabinet/dot.svg';
import { styles } from './styles';

interface ITrashFolderGridCard {
  name: string;
  size: number;
  itemsCount: number;
  onClick: () => void;
}

export const TrashFolderGridCard = ({ name, size, itemsCount, onClick }: ITrashFolderGridCard) => {
  return (
    <Grid sx={styles.container} onClick={onClick}>
      <Grid sx={styles.card}>
        <Grid sx={styles.cardHeader}>
          <TrashIcon />
        </Grid>
        <Grid sx={styles.cardContent}>
          <Grid sx={styles.contentContainer}>
            <CustomTooltip title={name}>
              <Typography sx={styles.folderName}>{name}</Typography>
            </CustomTooltip>
            <Grid sx={styles.details}>
              <Typography sx={styles.typo}>{convertBytes(Number(size), 2)}</Typography>
              <DotIcon />
              <Typography sx={styles.typo}>
                {itemsCount || '0'} {itemsCount && Number(itemsCount) === 1 ? 'file' : 'files'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
